import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';
import { ModalBody, ModalFooter, ModalTitle } from '@vds/modals';
import { selectStateCache } from './@selectors';
import { Title } from '../../common/Typography/index';
import { useMiniCartHooks } from './@Redux/OrderSummary.hooks';
import { priceFormat } from '../../common/Helpers';
import './MobileCart/mobileCart.css';
// import PromoCode from '../PromoCode';
import { VDSModal as Modal } from '../../common/Modal/VDSModal';
import './DesktopCart/desktopCart.css';
import DueTodayProduct from './DesktopCart/dueTodayProduct';
import DueMonthlyProduct from './DesktopCart/dueMonthlyProduct';
import { ReviewPriceContainer } from './layout.styles';

const ReviewPrice = (props) => {
  const stateCache = useSelector((state) => selectStateCache(state), shallowEqual);
  const { dueAmount } = useMiniCartHooks(stateCache);
  const { dueTodayAmount, dueMonthlyAmount } = dueAmount || {};

  const handleOpenChange = (val) => {
    if (!val) {
      props.showReviewPrice(!val);
    }
  };

  return (
    <>
      {' '}
      <Modal ariaLabel="Price Details" opened onOpenedChange={handleOpenChange} disableOutsideClick={false}>
        <ModalTitle>Price details</ModalTitle>
        <ModalBody id="reviewPriceBody">
          <ReviewPriceContainer>
            <div className="dueTodayHeader">
              <Title color="black" size="TitleSmall" bold>
                Due today
              </Title>
              <div>{priceFormat(dueTodayAmount)}</div>
            </div>
            <DueTodayProduct />
            <div className="dueMonthHeader">
              <Title color="black" size="TitleSmall" bold>
                Due monthly for 5G Home
              </Title>
              <div>{priceFormat(dueMonthlyAmount)}</div>
            </div>
            <DueMonthlyProduct />
          </ReviewPriceContainer>
        </ModalBody>
        <div className="priceModalFooter">
          <ModalFooter
            buttonData={{
              primary: {
                width: '100%',
                children: 'Close',
                'data-testid': 'Close',
                onClick: () => handleOpenChange(false),
              },
            }}
          />
        </div>
      </Modal>
    </>
  );
};

ReviewPrice.propTypes = {
  showReviewPrice: PropTypes.bool,
};

export default ReviewPrice;
